export default "__VITE_ASSET__D$dvnq7W__"